// extracted by mini-css-extract-plugin
module.exports = {"dialogSimilarType":"_3XZoH"};